import { useState } from "react";
import StorageIcon from "@mui/icons-material/Storage";
import { useNavigate } from "react-router-dom";
import { ImgMenu, SidebarNew } from "../molecules";
import { LogoContainer, SidebarContent, SidebarInnerContent } from "../atoms";
import logo from "../../assets/img/logo_sm.svg";
import { UserInfo } from "./UserInfo";
import { Submenu } from "./Submenu";
import { DEFAULT_SUBMENU } from "../../constants/submenu";
import { PATHS } from "../../constants/paths";

const MenuBar = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState("basics");

  const handleSubMenuChange = (name: string) => {
    setSelected(name);
  };

  const navigateToDefaultPage = () => {
    navigate(PATHS.Dashboard.Path);
    handleSubMenuChange(DEFAULT_SUBMENU);
  };

  return (
    <>
      <SidebarNew>
        <SidebarContent>
          <SidebarContent>
            <SidebarInnerContent>
              <LogoContainer pointer onClick={navigateToDefaultPage}>
                <img
                  alt="Logo"
                  src={logo}
                  height="42"
                  width="42"
                  style={{ borderRadius: "10px" }}
                />
              </LogoContainer>
              <ImgMenu
                Icon={StorageIcon}
                tooltip="Basics"
                selected={selected}
                name="basics"
                handleSelection={handleSubMenuChange}
              />
            </SidebarInnerContent>
          </SidebarContent>
          <SidebarInnerContent>
            <UserInfo />
          </SidebarInnerContent>
        </SidebarContent>
      </SidebarNew>
      <Submenu selected={selected} />
    </>
  );
};

export { MenuBar };
